import React from "react";
import { Check } from "lucide-react";

interface ProgressBarPreviewProps {
    settings: {
        steps: { label: string; id: string }[];
        currentStep: number;
        activeColor: string;
        completedColor: string;
        inactiveColor: string;
        style: "simple" | "numbered" | "icons";
    };
}

export const ProgressBarPreview: React.FC<ProgressBarPreviewProps> = ({ settings }) => {
    const steps = settings.steps || [
        { label: "عربة التسوق", id: "cart" },
        { label: "معلومات الشحن", id: "shipping" },
        { label: "الدفع", id: "payment" },
    ];

    const currentStep = settings.currentStep || 1;

    return (
        <div className="w-full py-6 px-4">
            <div className="relative flex justify-between items-center">
                {/* Progress Line Background */}
                <div className="absolute top-1/2 left-0 w-full h-1 bg-gray-200 -z-10 transform -translate-y-1/2" />

                {/* Active Progress Line */}
                <div
                    className="absolute top-1/2 right-0 h-1 transition-all duration-500 -z-10 transform -translate-y-1/2"
                    style={{
                        width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
                        backgroundColor: settings.activeColor
                    }}
                />

                {steps.map((step, index) => {
                    const stepNumber = index + 1;
                    const isCompleted = stepNumber < currentStep;
                    const isActive = stepNumber === currentStep;

                    return (
                        <div key={step.id} className="flex flex-col items-center gap-2 bg-white px-2">
                            <div
                                className={`w-8 h-8 rounded-full flex items-center justify-center border-2 transition-all duration-300 ${isActive ? "scale-110 shadow-md" : ""
                                    }`}
                                style={{
                                    backgroundColor: isCompleted ? settings.completedColor : isActive ? settings.activeColor : "white",
                                    borderColor: isCompleted ? settings.completedColor : isActive ? settings.activeColor : settings.inactiveColor,
                                    color: isCompleted || isActive ? "white" : settings.inactiveColor,
                                }}
                            >
                                {isCompleted ? (
                                    <Check className="w-5 h-5" />
                                ) : (
                                    <span className="font-bold text-sm">{stepNumber}</span>
                                )}
                            </div>
                            <span
                                className={`text-xs font-medium transition-colors duration-300 ${isActive ? "font-bold" : ""
                                    }`}
                                style={{
                                    color: isActive ? settings.activeColor : settings.inactiveColor
                                }}
                            >
                                {step.label}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
